import { Component } from 'react';
import PropTypes from 'prop-types';
import { notification } from 'antd';

class Notifications extends Component {
  componentDidMount() {
    this.openNotification();
  }

  openNotification = () => {
    const { type, title, description, duration } = this.props;
    notification[type]({
      message: title,
      description,
      duration,
    });
  };

  render() {
    return null;
  }
}

Notifications.defaultProps = {
  duration: 5000,
  description: '',
};

Notifications.propTypes = {
  description: PropTypes.string,
  duration: PropTypes.number,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['success', 'info', 'warning', 'error']).isRequired,
};

export default Notifications;
